import React, { useState, useRef, useEffect } from 'react';

type LoginProps = {
	open: boolean
	onSubmit: (token: string) => void
}

function Login({open, onSubmit}: LoginProps) {
	const [token, setToken] = useState("")

	return (
    <div tabIndex={-1} className={`fixed top-0 left-0 right-0 z-50 w-full p-12 overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full ${open? '' :'hidden'}`}>
	    <div className="relative w-full h-full flex flex-col justify-center">
	      <div className="rounded-lg shadow bg-gray-700 m-12">
	        <div className="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
	          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
	            Connect GPTChat Session
	          </h3>
	        </div>
	        <div className="p-6 space-y-6">
	          <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
	            Until GPTChat provides an official API & Auth, this requires connecting to an existing
	            GPTChat session.  You will need to login to GPTChat first and 
	            copy the <span className="font-mono font-bold">__Secure-next-auth.session-token</span> cookie here:
	          </p>
	          <textarea className="w-full" rows={5} onChange={e => setToken(e.target.value)}/>
	          <button type="button" className="border text-white rounded-md px-3 py-1" onClick={() => onSubmit(token)}>Connect</button>
	        </div>
	      </div>
	    </div>
	  </div>
  )
}

export default Login